import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OptionalBoolean = (props) => {
    const onChange = e => {
        switch (e.target.value) {
            case 'default':
                props.setValue(null);
                break;
            case 'no':
                props.setValue(false);
                break;
            case 'yes':
                props.setValue(true);
                break;
        }
    };
    let value;
    if (props.value == null) {
        value = 'default';
    }
    else if (props.value == false) {
        value = 'no';
    }
    else {
        value = 'yes';
    }
    return (_jsxs("select", { value: value, onChange: onChange, children: [_jsx("option", { value: 'default', children: "Default" }), _jsx("option", { value: 'no', children: "No" }), _jsx("option", { value: 'yes', children: "Yes" })] }));
};
